import React from 'react';
/* eslint-disable import/no-unresolved */
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import CardBody from '../../sharedComponents/Card/CardBody';
import Card from '../../sharedComponents/Card/Card';
import { useStyles } from './styles';

const InputEditList = props => {
  const { setIsEdit, isEdit, listItem, onChange, onDelete, onEditList } = props;
  const classes = useStyles();

  return (
    <Card>
      <CardBody>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <TextField
              label='Nombre'
              margin='normal'
              type='text'
              fullWidth
              disabled={isEdit}
              value={listItem.nombre || ''}
              onChange={event => onChange(event, 'nombre')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <TextField
              label='Descripción'
              margin='normal'
              type='text'
              fullWidth
              disabled={isEdit}
              value={listItem.descripcion || ''}
              onChange={event => onChange(event, 'descripcion')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.justify} item xs={12} sm={2} md={3}>
            <IconButton size='small' onClick={() => setIsEdit(!isEdit)}>
              <EditIcon />
            </IconButton>
            <IconButton size='small' onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
            {!isEdit && (
              <IconButton size='small' onClick={onEditList}>
                <SaveIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
};

export default InputEditList;
